import { Theme, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { CardContent, Typography } from '@material-ui/core';
import { FlexContainer } from '../../../../layout/Flex';

export const ReportCardOuterContainer = styled('div')((p) => ({
  padding: p.theme.spacing(4),
  border: p.theme.custom.border.standard,
  borderRadius: p.theme.custom.border.radius()
}));

export const ReportCardInnerContainer = CardContent;

const SubTitle = styled('div')((p) => ({
  color: p.theme.custom.colors.gray.w500,
  fontSize: p.theme.custom.fontSize.m
}));

const REPORT_CARD_ICON_SIZE = 22;

export const ReportCard: React.FC<{
  icon?: (args: {
    size: number;
    colors: Theme['custom']['colors'];
  }) => React.ReactElement;
  title: React.ReactElement;
  subTitle?: React.ReactElement;
  actions?: React.ReactElement;
  noContentPadding?: boolean;
}> = ({ icon, title, subTitle, actions, noContentPadding, children }) => {
  const theme = useTheme();
  return (
    <ReportCardOuterContainer>
      <FlexContainer justifyContent="space-between" marginBottom={4}>
        <div>
          <FlexContainer marginBottom={1}>
            {icon &&
              icon({
                size: REPORT_CARD_ICON_SIZE,
                colors: theme.custom.colors
              })}
            <Typography variant="h3">{title}</Typography>
          </FlexContainer>
          {subTitle && <SubTitle>{subTitle}</SubTitle>}
        </div>
        {actions && <div>{actions}</div>}
      </FlexContainer>
      {noContentPadding ? (
        <div>{children}</div>
      ) : (
        <ReportCardInnerContainer>{children}</ReportCardInnerContainer>
      )}
    </ReportCardOuterContainer>
  );
};
